import { EmptyTextData } from 'library/types';

import { StyledLink } from './CustomLink';

export const PhoneNumberLink = ({
	phoneNumber,
}: {
	phoneNumber: EmptyTextData;
}): React.JSX.Element | null =>
	phoneNumber ? (
		<StyledLink href={`tel:${phoneNumber}`} color="secondary">
			{phoneNumber}
		</StyledLink>
	) : null;
